export const fonts = {
    gotham: "'Gotham Rounded', arial, sans-serif",
    gothamBook: "'Gotham Rounded Book', arial, sans-serif",
};
